var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Bind"}},[_c('div',{staticClass:"g-right-top width800"},[_vm._v("个人中心／编辑资料／基本信息")]),_vm._v(" "),_c('div',{staticClass:"g-right-middle margintop20 width800"},[_vm._v("\n       该功能正在开发中   ING......      \n\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ff0b3ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/per_admin/P_Bind.vue
// module id = null
// module chunks = 